// extracted by mini-css-extract-plugin
module.exports = {"title":"musicians-list-page_title__3k37w"};